import { Group } from '@/components/_common';
import { useWorkorderItems } from '.';
import { useWorkorderDetailContext } from '../../WorkorderDetailProvider';
import { Button, Switch } from 'antd';
import SpaceForButton from '@/components/_common/SpaceForButtons';
import PartsFragaList from './PartsFragaList';
import { PartListType } from './WorkOrderSteps';
import { useFragaPartsContext } from './FragaPartsProvider';
import PartsSystemList from './PartsSystemList';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import { AuthorityWorkorder } from '@/types/Authority/Authority.Workorder';

interface Props {
  onCancel: VoidFunction;
  partListType: PartListType;
  setPartListType: (value: PartListType) => void;
}

function SelectPartList({ onCancel, partListType, setPartListType }: Props) {
  const {
    workorder: { data: workorder },
  } = useWorkorderDetailContext();

  const { fragaParts, setFragaParts } = useFragaPartsContext();
  const { items, setItems } = useWorkorderItems();

  const { onNextStep, onPrevStep } = useWorkorderItems();

  function onNext() {
    if (partListType === PartListType.PARTS_FRAGA && !fragaParts.length) {
      return;
    }

    onNextStep();
  }

  return (
    <>
      {!!workorder?.vehicle && (
        <>
          <Group gap={10} style={{ marginBottom: 24 }}>
            <strong>Catalogo Fraga</strong>
            <Switch
              checkedChildren="Sim"
              unCheckedChildren="Não"
              checked={partListType === PartListType.PARTS_FRAGA}
              onChange={(check) =>
                setPartListType(
                  check ? PartListType.PARTS_FRAGA : PartListType.PARTS_SYSTEM,
                )
              }
              disabled={!!fragaParts.length || !!items.length}
            />

            {(!!fragaParts.length || !!items.length) && (
              <Button
                onClick={() => {
                  setItems([]);
                  setFragaParts([]);
                }}
              >
                Limpar seleção
              </Button>
            )}
          </Group>
        </>
      )}

      {partListType === PartListType.PARTS_SYSTEM && <PartsSystemList />}

      {partListType === PartListType.PARTS_FRAGA && <PartsFragaList />}

      <SpaceForButton justifyContent="end" style={{ marginTop: 10 }}>
        <Button
          block
          onClick={() => {
            onCancel();
            setPartListType(PartListType.PARTS_SYSTEM);
            setFragaParts([]);
          }}
        >
          Cancelar
        </Button>

        <Button
          block
          onClick={() => {
            onPrevStep();
            setPartListType(PartListType.PARTS_SYSTEM);
            setFragaParts([]);
          }}
        >
          Voltar
        </Button>

        <Button
          block
          type="primary"
          disabled={
            (!hasPermissions([
              AuthorityWorkorder.MOVIMENTATION_WORKORDER_ADD_PART_SERVICE_TYPED,
            ]) &&
              items?.length < 1) ||
            (partListType === PartListType.PARTS_FRAGA && !fragaParts.length)
          }
          onClick={onNext}
        >
          Próximo
        </Button>
      </SpaceForButton>
    </>
  );
}

export default SelectPartList;
